import styles from './styles.module.scss'
import { Avatar } from 'app/components'
import AiBotIcon from 'app/components/icons/AiBot'

function OperatorAvatar({ isBotAvatar, size, name, avatarUrl }) {
  if (isBotAvatar) {
    return (
      <div className={styles.ai_bot_avatar}>
        <AiBotIcon pureSvg={true} />
      </div>
    )
  }

  return (
    <Avatar
      backgroundSize={size}
      withBorder={false}
      showTooltip={false}
      avatarInfo={{
        name,
        url: avatarUrl,
      }}
    />
  )
}

export default OperatorAvatar
